import React from 'react';

import { Skeleton, SkeletonText } from '@/components/ui/skeleton';
import { cn } from '@/utils';

import { ProductColors } from './product-colors';

export const VariantLoading: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn('group grid text-black hover:no-underline', className)}
    {...rest}
  >
    <Skeleton className="block aspect-square h-full w-full" />
    <div className="flex flex-col gap-2 px-4 py-2">
      <div className="flex items-start justify-between gap-2">
        <SkeletonText className="w-1/4 text-lg/none font-bold">
          Loading
        </SkeletonText>
        <ProductColors colors={['#eee', '#eed']} />
      </div>
      <SkeletonText className="w-1/2 text-base/none font-bold">
        Loading
      </SkeletonText>
      <SkeletonText className="w-1/6 text-base/none">Loading</SkeletonText>
    </div>
  </div>
);
